export default {
  zh: {
    workflow: '工作流',
    createNew: '创建',
    action: '操作',
    status: '状态',
    workflowCode: '工作流代码',
    workflowName: '工作流名称',
    createdBy: '创建者',
    createdDate: '创建时间',
    triggerType: '触发类型',
    description: '描述',
    executionHistory: '执行历史',
    actionsLog: '动作日志',
    filterFailures: '筛选失败日志',
    executionDate: '执行日期',
    errMsg: '错误信息',
  },
  en: {
    workflow: 'Workflow',
    createNew: 'Create New',
    action: 'Action',
    status: 'Status',
    workflowCode: 'Workflow Code',
    workflowName: 'Workflow Name',
    createdBy: 'Created By',
    createdDate: 'Created Date',
    triggerType: 'Trigger Type',
    description: 'Description',
    executionHistory: 'Execution History',
    actionsLog: 'Actions Log',
    filterFailures: 'Filter Failures',
    executionDate: 'Execution Date',
    errMsg: 'Error Message',
  }
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/i18n.js